<template>
    <div :style="backgroundStyle">
        <div v-if="ieBlock">
            <p>Diese Anwendung läuft leider nicht mehr auf dem veralteten Internet Explorer.</p>
            <p>Wir empfehlen die Verwendung von Google Chrome, du kannst aber auch jeden anderen
                modernen Browser nutzen (z.B. Microsoft Edge, Firefox, Opera oder Safari für Apple).</p>
        </div>
        <div v-else>
            <v-app-bar app color="primary" dark dense
                       v-if="$route.path !== '/Ergebnisdienst/PrintWurfzettel' &&
                             $route.path !== '/Ergebnisdienst/PrintDatenblatt' &&
                             $route.path !== '/Ergebnisdienst/PrintTabellen' &&
                             $route.path !== '/Ergebnisdienst/PrintTabelle' &&
                             $route.path !== '/Ergebnisdienst/PrintSchnittliste' &&
                             $route.path !== '/Ergebnisdienst/PrintSpiele'&&
                             $route.path !== '/Ergebnisdienst/Stream'&&
                             $route.path !== '/Ergebnisdienst/PrintMeisterschaft'">
                <img width="40" src="./assets/oeskb.png"
                     style="background-color: white; border-radius: 20px;"
                     class="elevation-4 mr-3" @click="goToHome()">
                <div class="d-flex align-center heebo fs20" @click="goToHome()">
                    ÖSKB <span v-if="$route.path !== '/Ergebnisdienst' && $route.path !== '/Ergebnisdienst/AntiDoping'"
                               class="ml-1">Ergebnisdienst</span>
                </div>
                <v-spacer></v-spacer>
                <v-tooltip left v-if="user.uid" >
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon class="mr-1"  v-bind="attrs" v-on="on">mdi-account-check</v-icon>
                    </template>
                    <span>angemeldet als {{user.email}}</span>
                </v-tooltip>

                <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn dark icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list max-height="600px" class="pa-0 overflow-y-auto">
                        <v-list-item @click="navigate('Ergebnisdienst')">
                            <v-list-item-icon class="mr-2"><v-icon>mdi-format-list-numbered</v-icon></v-list-item-icon>
                            <v-list-item-title>Ergebnisdienst</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="navigate('Ergebnisdienst/Spielberichte')">
                            <v-list-item-icon class="mr-2"><v-icon>mdi-file-document-outline</v-icon></v-list-item-icon>
                            <v-list-item-title>Spielberichte verwalten</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="navigate('Ergebnisdienst/SpielberichteFremd')">
                            <v-list-item-icon class="mr-2"><v-icon>mdi-file-document-outline</v-icon></v-list-item-icon>
                            <v-list-item-title>Spiel-Administrator</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="navigate('Ergebnisdienst/Vereinsdatenblatt')">
                            <v-list-item-icon class="mr-2"><v-icon>mdi-file-table</v-icon></v-list-item-icon>
                            <v-list-item-title>Vereinsdatenblatt</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="navigate('Ergebnisdienst/AntiDoping')">
                            <v-list-item-icon class="mr-2"><v-icon>mdi-file-table</v-icon></v-list-item-icon>
                            <v-list-item-title>ADE/DSV/Ärtzl.Attest</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="user && user.permissions.userAdmin"
                                     @click="navigate('Ergebnisdienst/UserAdmin')">
                            <v-list-item-icon class="mr-2"><v-icon>mdi-account-edit</v-icon></v-list-item-icon>
                            <v-list-item-title>Benutzerverwaltung</v-list-item-title>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item v-if="user && user.permissions.pass"
                                     @click="navigate('paesse')">
                            <v-list-item-icon class="mr-2"><v-icon>mdi-account-supervisor-circle</v-icon></v-list-item-icon>
                            <v-list-item-title>ÖSKB-Pass</v-list-item-title>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item @click="navigate('Ergebnisdienst/Hilfe')">
                            <v-list-item-icon class="mr-2"><v-icon>mdi-help-circle</v-icon></v-list-item-icon>
                            <v-list-item-title>Hilfe</v-list-item-title>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item v-if="!user.uid" @click="login()">
                            <v-list-item-icon class="mr-2"><v-icon>mdi-login</v-icon></v-list-item-icon>
                            <v-list-item-title>Anmelden</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="user.uid" @click="resetPW">
                            <v-list-item-icon class="mr-2"><v-icon>mdi-account-key</v-icon></v-list-item-icon>
                            <v-list-item-title>Passwort ändern</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="user.uid" @click="logout()">
                            <v-list-item-icon class="mr-2"><v-icon>mdi-logout</v-icon></v-list-item-icon>
                            <v-list-item-title>Abmelden</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-app-bar>
            <!-- login or sign up if user unknown -->
            <authentication v-if="!user.uid && loginRequested" class="authentication"></authentication>
            <v-main v-else>
                <!--<div v-if="1===1" class="ma-10">
                    <p class="title">Ergebnisdienst</p>
                    Dieses Service startet voraussichtlich am 20.8.2021!
                </div>-->
                <router-view></router-view>
            </v-main>
        </div>
    </div>
</template>

<script>
    import firebase from 'firebase/app'
    import 'firebase/auth'
    import Authentication from "./views/authentication/authentication";
    import {db} from './services/db'

    export default {
        components: {
                        Authentication},
        name: "app-ergebnisdienst",
        props: ['ieBlock'],
        computed: {
            user(){ return this.$store.state.user; },
            backgroundStyle(){
                return this.$route.path==='/Ergebnisdienst/Stream' ? 'background: none transparent; margin: 0;' : '';
            },
        },
        data: () => ({
            loginRequested: false,
        }),
        created(){
            this.setLoginRequested();
            this.loadFristen();
        },
        methods: {
            login(){
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.login = true;
                this.$router.push({path: p, query: q});
            },
            logout(){
                this.loginRequested = false;
                firebase.auth().signOut();
                window.location.reload(true);
            },
            resetPW(){
                firebase.auth().sendPasswordResetEmail(this.user.email)
                    .then( () => {
                        this.$store.dispatch('clearSnackbar');
                        this.$store.state.globalSnack.color = 'success';
                        this.$store.state.globalSnack.text = 'Du hast ein eMail mit einem Link zum Ändern des Passworts erhalten!';
                        this.$store.state.globalSnack.show = true;
                    }).catch( (error) => {
                    this.$store.dispatch('clearSnackbar');
                    this.$store.state.globalSnack.show = true;
                    this.$store.state.globalSnack.color = 'error';
                    this.$store.state.globalSnack.text = error.message;
                });
            },
            navigate(target){
                console.log ("target", target);
                console.log ("this.$router.path", this.$route.path);
                if ( '/' + target !== this.$route.path ) {
                    this.$router.push({path: '/' + target})
                } else if ( target === 'Ergebnisdienst' && this.loginRequested) {
                    this.loginRequested = false;
                    window.history.back();
                }
            },
            goToHome(){
                if ( this.$route.path !== '/Ergebnisdienst' ) { this.$router.push('/Ergebnisdienst') }
            },
            setLoginRequested(){
                if ( !this.$route.query.login ) {
                    this.loginRequested = false;
                } else {
                    this.loginRequested = true;
                }
            },
            closeLoginWindow(){
                if ( this.user.uid && this.$route.query.login ) {
                    let p = JSON.parse(JSON.stringify(this.$route.path));
                    let q = JSON.parse(JSON.stringify(this.$route.query));
                    delete q.login;
                    this.$router.replace({path: p, query: q});
                }
            },
            setVereinsdatenblattAlert(){
                if ( this.user.permissions.spielbericht && this.user.permissions.spielbericht.length > 4 ) {
                    db.collection("vereinsdatenblaetter")
                        .doc(this.user.permissions.spielbericht)
                        .get().then((doc) => {
                        if (!doc.exists) {
                            this.$store.dispatch('clearSnackbar');
                            this.$store.state.globalSnack.timeout = 7000;
                            this.$store.state.globalSnack.color = 'warning';
                            this.$store.state.globalSnack.text = 'Du hast das Vereinsdatenblatt ' +
                                'für deinen Verein noch nicht gewartet, bitte fülle es so bald wie möglich! ' +
                                'Du findest das Vereinsdatenblatt im Menü rechts oben!';
                            this.$store.state.globalSnack.show = true;
                        }
                    }).catch((error) => {
                        console.log("Error getting document:", error);
                    });
                }
            },
            loadFristen(){
                this.$store.state.snapshots.bestaetigungsfristen = [];
                db.collection("fristen").get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        this.$store.state.snapshots.bestaetigungsfristen.push(
                            {id: doc.id, ...doc.data()}
                        );
                        console.log(doc.id, " => ", doc.data());
                    });
                });
            }
        },
        watch: {
            '$route.query.login'(){
                this.setLoginRequested();
            },
            'user.uid'(){
                this.closeLoginWindow();
            },
            'user.permissions'(){
                this.setVereinsdatenblattAlert();
            }
        }
    }
</script>

<style scoped>
    .authentication {position: absolute; top: 34px; bottom: 0;}
</style>